import { Bridge } from '@mc/mc-jsbridge'
import { miniProgramEnv } from '@/defines/environment'
import { mpsCombination } from '../native_interactions/mps_combination'

export const back = () => {
  if (Bridge.prepared) {
    Bridge.navigateBack()
  } else if (miniProgramEnv.isMiniProgram) {
    mpsCombination.navigateBack()
  } else {
    history.back()
  }
}
